import { Grid } from '@mui/material';
import React from 'react';
import PageHeader from '../pageHeader/PageHeader';
import CustomTextField from '../formFields/textField';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { USER_ROLES } from 'src/config/enum';

const CustomerDetails = ({ data }) => {
  const { user } = useSelector((state) => state.auth);
  return (
    <>
      <PageHeader pageTitle={t('orderDetailsPage.customerDetails')} />
      <Grid container xs={12} spacing={4} sx={{ mt: 2, fontWeight: 600, color: '#515151' }}>
        <Grid item xs={12}>
          <CustomTextField disabled value={data.firstName + ' ' + data.lastName} label={t('common.name')} />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField disabled value={data.email} label={'Email'} />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField disabled value={data.phoneNumber} label={t('common.phone')} />
        </Grid>
        {user.role !== USER_ROLES.CUSTOMER && (
          <>
            <Grid item xs={12}>
              <CustomTextField disabled value={data.role} label={t('common.role')} />
            </Grid>
            <Grid item xs={12}>
              <CustomTextField disabled value={data.status} label={t('common.status')} />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default CustomerDetails;
